// Radio values double as the reason text sent to the backend, following the
// cancellation feedback pattern in
// frontend/src/components/Shipper/components/CancelShipmentForm/CancelShipmentFormModalContent.tsx
export const REPORT_REASONS = [
  "Soliciting/taking deal off platform",
  "Harassment",
  "Spam",
] as const;

export const OTHER_REASON_VALUE = "other";

interface ReportCopy {
  title: string;
  prompt: string;
}

// Keyed by resource type so adding a flaggable resource on the backend is a
// compile error here rather than a modal that silently says "question".
export const REPORT_COPY: Record<FlaggableResourceType, ReportCopy> = {
  SHIPMENT_QA_QUESTION: {
    title: "Report Question",
    prompt:
      "Tell us what is wrong with this question so our team can review it. A reason is optional but helps us act faster.",
  },
};
